/**
 * Invite-only sign-up (PB-64 / PB-60): recognise a refusal from Firebase's
 * account-creation check (`functions/src/triggers/beforeUserCreated.ts`).
 *
 * The check throws `permission-denied` with the message
 * `NO_INVITATION <email>`; the browser gets it as `auth/internal-error` with
 * that text inside the error message.
 */
const NO_INVITATION = 'NO_INVITATION'

/**
 * The refused email address when the error is that refusal ('' if the
 * address couldn't be read from it), or null for any other error.
 */
export function noInvitationEmail(error: unknown): string | null {
  const message = String((error as { message?: unknown })?.message ?? '')
  if (!message.includes(NO_INVITATION)) return null
  const match = message.match(/NO_INVITATION ([^\s"\\]+@[^\s"\\]+)/)
  return match?.[1] ?? ''
}

const REFUSED_KEY = 'mntnd-refused-email'

/**
 * When the app signs someone out because their record is deleted (PB-74), the
 * sign-in page shows the same no-invitation notice. The address crosses the
 * sign-out in sessionStorage.
 */
export function rememberRefusedEmail(email: string): void {
  try {
    sessionStorage.setItem(REFUSED_KEY, email)
  } catch {
    // Storage unavailable: the page just shows no notice
  }
}

/** The remembered address, once (cleared on read), or null. */
export function takeRefusedEmail(): string | null {
  try {
    const email = sessionStorage.getItem(REFUSED_KEY)
    sessionStorage.removeItem(REFUSED_KEY)
    return email
  } catch {
    return null
  }
}
